import {email,phone,name,verifyCode,password,testPassword} from "./formValidate"

const filter_rules = item=>{
  let rules = [];
  if(item.required){
    rules.push({ required: true, message: '该输入项为必填项!', trigger: 'blur' });
  }
  if(item.min&&item.max){       
   rules.push({ min:item.min,max:item.max, message: '字符长度在'+item.min+'至'+item.max+'之间!', trigger: 'blur' })
  }
  if(item.type){
    let type = item.type
    switch(type){
      case "email":
      rules.push({ validator: email, message: '请输入正确的邮箱地址', trigger: ['blur','change']});
      break
      case "phone":
      rules.push({ validator: phone, message: '手机号格式不正确', trigger: ['blur','change']})
      break
      case "name":
      rules.push({ validator: name, message: '请输入中文', trigger: ['blur','change']})
      break
      case "verifyCode":
      rules.push({ validator: verifyCode,verifyCode:item.verifyCode, message: '请输入正确验证码', trigger: ['blur']})
      break
      case "password":
      rules.push({ validator: testPassword, message: '密码至少包含数字、大、小英文字符两种以上', trigger: ['blur']})
      rules.push({ validator: password,status:item.value,mode:item.mode, message: '两次密码不一致', trigger: ['blur']})
      break
    }
  }
  return rules;
}
export default filter_rules


// WEBPACK FOOTER //
// ./src/utils/filter_rules.js